import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spacer, Stack } from '@emburse/embark-core';
export default function ForteApplicationFormRow({ bottomSpacer, children }) {
    return (_jsxs(Stack, { alignItems: "flex-start", sx: { width: '100%' }, children: [_jsx(Stack, { alignItems: "flex-start", direction: "row", justifyContent: "space-between", spacing: 3, sx: { width: '100%' }, children: children }), bottomSpacer && _jsx(Spacer, { size: 24 })] }));
}
ForteApplicationFormRow.defaultProps = {
    bottomSpacer: false
};
